"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var bind_1 = require("../bind");
var ANIMATION_DURATION = 600;
var RIGHT = 'right';
var LEFT = 'left';
var ImageCarousel = /** @class */ (function (_super) {
    tslib_1.__extends(ImageCarousel, _super);
    function ImageCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            nextIndex: 0,
            index: 0,
            isAnimating: false,
            animationClass: '',
            clicked: false,
        };
        return _this;
    }
    ImageCarousel.prototype.onClickLeft = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.scroll(LEFT);
    };
    ImageCarousel.prototype.onClickRight = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.scroll(RIGHT);
    };
    ImageCarousel.prototype.getNextIndex = function (dir) {
        var max = this.props.images.length - 1;
        var next = dir === RIGHT ? this.state.index + 1 : this.state.index - 1;
        if (next < 0) {
            return max;
        }
        if (next > max) {
            return 0;
        }
        return next;
    };
    ImageCarousel.prototype.scroll = function (dir) {
        var _this = this;
        if (this.state.isAnimating) {
            return;
        }
        var animationClass = "image-carousel--click-" + dir;
        this.setState({
            animationClass: animationClass,
            nextIndex: this.getNextIndex(dir),
            isAnimating: true,
            clicked: true,
        });
        setTimeout(function () {
            _this.setState({
                animationClass: '',
                index: _this.state.nextIndex,
                isAnimating: false,
            });
        }, ANIMATION_DURATION);
    };
    ImageCarousel.prototype.renderCloudinaryImage = function (image, key) {
        if (!image) {
            return false;
        }
        return React.createElement("img", { key: key, src: image, alt: this.props.imgAlt, loading: "lazy" });
    };
    ImageCarousel.prototype.renderImageSlide = function (path, key) {
        return (React.createElement("div", { className: "image-carousel__slide" }, this.renderCloudinaryImage(path, key)));
    };
    ImageCarousel.prototype.renderButtons = function () {
        if (this.props.images.length <= 1) {
            return false;
        }
        return (React.createElement("div", null,
            React.createElement("button", { onClick: this.onClickLeft, className: "image-carousel__control image-carousel__control--" + LEFT, tabIndex: -1, "aria-label": I18n.t('commons.previousImage') }),
            React.createElement("button", { onClick: this.onClickRight, className: "image-carousel__control image-carousel__control--" + RIGHT, tabIndex: -1, "aria-label": I18n.t('commons.nextImage') })));
    };
    // renders a hidden div with all of the images to force the browser
    // to fetch and cache.
    ImageCarousel.prototype.renderPrefetch = function () {
        var _this = this;
        if (!this.state.clicked) {
            return false;
        }
        return this.props.images.map(function (image, i) { return _this.renderCloudinaryImage(image, i); });
    };
    ImageCarousel.prototype.render = function () {
        var image = this.props.images[this.state.index];
        var nextImage = this.state.isAnimating ? this.props.images[this.state.nextIndex] : null;
        return (React.createElement("div", { className: classNames('image-carousel', this.state.animationClass) },
            React.createElement("div", { className: "image-carousel__prefetch" }, this.renderPrefetch()),
            React.createElement("div", { className: "image-carousel__slides" },
                this.renderImageSlide(nextImage, 1),
                this.renderImageSlide(image, 2),
                this.renderImageSlide(nextImage, 3)),
            this.renderButtons()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ImageCarousel.prototype, "onClickLeft", null);
    tslib_1.__decorate([
        bind_1.default
    ], ImageCarousel.prototype, "onClickRight", null);
    tslib_1.__decorate([
        bind_1.default
    ], ImageCarousel.prototype, "scroll", null);
    return ImageCarousel;
}(React.Component));
exports.default = ImageCarousel;
//# sourceMappingURL=image_carousel.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/image_carousel.js
// module id = ld7n
// module chunks = 20 21